import Papa from 'papaparse';

export const download = (content: string, filename: string, options = {}) => {
    const a = document.createElement('a');
    const blob = new Blob([content], options);
    const url = URL.createObjectURL(blob);

    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    a.click();

    URL.revokeObjectURL(url);
};

export const prepareCsv = (fields: Array<string>, data: Array<object>) => {
    return Papa.unparse(
        {
            fields: fields,
            data: data,
        },
        { escapeFormulae: true }
    );
};
